import { render, staticRenderFns } from "./TokenDescription.vue?vue&type=template&id=a9a45e2a&"
import script from "./TokenDescription.vue?vue&type=script&lang=js&"
export * from "./TokenDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports